import { Action } from '@ngrx/store';
import { SoffApiExceptionDto, SoffApiResponseDto } from '@soff/shared-ui';
import {
  DisplayStatus,
  EscalationPattern,
  TscEmployeeSto,
  TscRegionSto,
  TscSalesOrganizationDto,
  TscTicketQueryDto,
  TscWorkshopSto,
} from '@soff/tsc-ui/core';

export const GET_DISPLAY_STATUS = '[TSC Status Hub] Get Display Status';
export const GET_DISPLAY_STATUS_SUCCESS = '[TSC Status Hub] Get Display Status Success';
export const GET_DISPLAY_STATUS_FAILURE = '[TSC Status Hub] Get Display Status Failure';

export class GetDisplayStatus implements Action {
  readonly type = GET_DISPLAY_STATUS;
  constructor(public payload: TscTicketQueryDto) {}
}
export class GetDisplayStatusSuccess implements Action {
  readonly type = GET_DISPLAY_STATUS_SUCCESS;
  constructor(public response: SoffApiResponseDto) {}
}
export class GetDisplayStatusFailure implements Action {
  readonly type = GET_DISPLAY_STATUS_FAILURE;
  constructor(public error: SoffApiExceptionDto) {}
}

export const CREATE_DISPLAY_STATUS = '[TSC Status Hub] Create Display Status';
export const CREATE_DISPLAY_STATUS_SUCCESS = '[TSC Status Hub] Create Display Status Success';
export const CREATE_DISPLAY_STATUS_FAILURE = '[TSC Status Hub] Create Display Status Failure';

export class CreateDisplayStatus implements Action {
  readonly type = CREATE_DISPLAY_STATUS;
  constructor(public payload: DisplayStatus) {}
}
export class CreateDisplayStatusSuccess implements Action {
  readonly type = CREATE_DISPLAY_STATUS_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: DisplayStatus
  ) {}
}
export class CreateDisplayStatusFailure implements Action {
  readonly type = CREATE_DISPLAY_STATUS_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: DisplayStatus
  ) {}
}

export const UPDATE_DISPLAY_STATUS = '[TSC Status Hub] Update Display Status';
export const UPDATE_DISPLAY_STATUS_SUCCESS = '[TSC Status Hub] Update Display Status Success';
export const UPDATE_DISPLAY_STATUS_FAILURE = '[TSC Status Hub] Update Display Status Failure';

export class UpdateDisplayStatus implements Action {
  readonly type = UPDATE_DISPLAY_STATUS;
  constructor(public payload: DisplayStatus) {}
}
export class UpdateDisplayStatusSuccess implements Action {
  readonly type = UPDATE_DISPLAY_STATUS_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: DisplayStatus
  ) {}
}
export class UpdateDisplayStatusFailure implements Action {
  readonly type = UPDATE_DISPLAY_STATUS_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: DisplayStatus
  ) {}
}

export const GET_ESCALATION_PATTERNS = '[TSC Status Hub] Get Escalation Patterns';
export const GET_ESCALATION_PATTERNS_SUCCESS = '[TSC Status Hub] Get Escalation Patterns Success';
export const GET_ESCALATION_PATTERNS_FAILURE = '[TSC Status Hub] Get Escalation Patterns Failure';
export class GetEscalationPatterns implements Action {
  readonly type = GET_ESCALATION_PATTERNS;
  constructor(public payload: TscTicketQueryDto) {}
}
export class GetEscalationPatternsSuccess implements Action {
  readonly type = GET_ESCALATION_PATTERNS_SUCCESS;
  constructor(public response: SoffApiResponseDto) {}
}
export class GetEscalationPatternsFailure implements Action {
  readonly type = GET_ESCALATION_PATTERNS_FAILURE;
  constructor(public error: SoffApiExceptionDto) {}
}

export const CREATE_ESCALATION_PATTERN = '[TSC Status Hub] Create Escalation Pattern';
export const CREATE_ESCALATION_PATTERN_SUCCESS = '[TSC Status Hub] Create Escalation Pattern Success';
export const CREATE_ESCALATION_PATTERN_FAILURE = '[TSC Status Hub] Create Escalation Pattern Failure';
export class CreateEscalationPattern implements Action {
  readonly type = CREATE_ESCALATION_PATTERN;
  constructor(public payload: EscalationPattern) {}
}
export class CreateEscalationPatternSuccess implements Action {
  readonly type = CREATE_ESCALATION_PATTERN_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: EscalationPattern
  ) {}
}
export class CreateEscalationPatternFailure implements Action {
  readonly type = CREATE_ESCALATION_PATTERN_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: EscalationPattern
  ) {}
}

export const UPDATE_ESCALATION_PATTERN = '[TSC Status Hub] Update Escalation Pattern';
export const UPDATE_ESCALATION_PATTERN_SUCCESS = '[TSC Status Hub] Update Escalation Pattern Success';
export const UPDATE_ESCALATION_PATTERN_FAILURE = '[TSC Status Hub] Update Escalation Pattern Failure';
export class UpdateEscalationPattern implements Action {
  readonly type = UPDATE_ESCALATION_PATTERN;
  constructor(public payload: Partial<EscalationPattern> & Pick<EscalationPattern, 'aggregateId'>) {}
}
export class UpdateEscalationPatternSuccess implements Action {
  readonly type = UPDATE_ESCALATION_PATTERN_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: Partial<EscalationPattern> & Pick<EscalationPattern, 'aggregateId'>
  ) {}
}
export class UpdateEscalationPatternFailure implements Action {
  readonly type = UPDATE_ESCALATION_PATTERN_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: Partial<EscalationPattern> & Pick<EscalationPattern, 'aggregateId'>
  ) {}
}

export const GET_VKORGS = '[TSC Regions] Get VKORGS';
export const GET_VKORGS_SUCCESS = '[TSC Regions] Get VKORGS Success';
export const GET_VKORGS_FAILURE = '[TSC Regions] Get VKORGS Failure';
export class GetVkorgs implements Action {
  readonly type = GET_VKORGS;
  constructor(public payload: TscTicketQueryDto) {}
}
export class GetVkorgsSuccess implements Action {
  readonly type = GET_VKORGS_SUCCESS;
  constructor(public response: SoffApiResponseDto) {}
}
export class GetVkorgsFailure implements Action {
  readonly type = GET_VKORGS_FAILURE;
  constructor(public error: SoffApiExceptionDto) {}
}

export const CREATE_VKORG = '[TSC Regions] Create VKORG';
export const CREATE_VKORG_SUCCESS = '[TSC Regions] Create VKORG Success';
export const CREATE_VKORG_FAILURE = '[TSC Regions] Create VKORG Failure';
export class CreateVkorg implements Action {
  readonly type = CREATE_VKORG;
  constructor(public payload: TscSalesOrganizationDto) {}
}
export class CreateVkorgSuccess implements Action {
  readonly type = CREATE_VKORG_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: TscSalesOrganizationDto
  ) {}
}
export class CreateVkorgFailure implements Action {
  readonly type = CREATE_VKORG_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: TscSalesOrganizationDto
  ) {}
}

export const UPDATE_VKORG = '[TSC Regions] Update VKORG';
export const UPDATE_VKORG_SUCCESS = '[TSC Regions] Update VKORG Success';
export const UPDATE_VKORG_FAILURE = '[TSC Regions] Update VKORG Failure';
export class UpdateVkorg implements Action {
  readonly type = UPDATE_VKORG;
  constructor(public payload: Partial<TscSalesOrganizationDto> & Pick<TscSalesOrganizationDto, 'aggregateId'>) {}
}
export class UpdateVkorgSuccess implements Action {
  readonly type = UPDATE_VKORG_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: Partial<TscSalesOrganizationDto> & Pick<TscSalesOrganizationDto, 'aggregateId'>
  ) {}
}
export class UpdateVkorgFailure implements Action {
  readonly type = UPDATE_VKORG_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: Partial<TscSalesOrganizationDto> & Pick<TscSalesOrganizationDto, 'aggregateId'>
  ) {}
}

export const GET_REGIONS = '[TSC Regions] Get Regions';
export const GET_REGIONS_SUCCESS = '[TSC Regions] Get Regions Success';
export const GET_REGIONS_FAILURE = '[TSC Regions] Get Regions Failure';
export class GetRegions implements Action {
  readonly type = GET_REGIONS;
  constructor(public payload: TscTicketQueryDto) {}
}
export class GetRegionsSuccess implements Action {
  readonly type = GET_REGIONS_SUCCESS;
  constructor(public response: SoffApiResponseDto) {}
}
export class GetRegionsFailure implements Action {
  readonly type = GET_REGIONS_FAILURE;
  constructor(public error: SoffApiExceptionDto) {}
}

export const CREATE_REGION = '[TSC Regions] Create Region';
export const CREATE_REGION_SUCCESS = '[TSC Regions] Create Region Success';
export const CREATE_REGION_FAILURE = '[TSC Regions] Create Region Failure';
export class CreateRegion implements Action {
  readonly type = CREATE_REGION;
  constructor(public payload: TscRegionSto) {}
}
export class CreateRegionSuccess implements Action {
  readonly type = CREATE_REGION_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: TscRegionSto
  ) {}
}
export class CreateRegionFailure implements Action {
  readonly type = CREATE_REGION_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: TscRegionSto
  ) {}
}

export const UPDATE_REGION = '[TSC Regions] Update Region';
export const UPDATE_REGION_SUCCESS = '[TSC Regions] Update Region Success';
export const UPDATE_REGION_FAILURE = '[TSC Regions] Update Region Failure';
export class UpdateRegion implements Action {
  readonly type = UPDATE_REGION;
  constructor(public payload: Partial<TscRegionSto> & Pick<TscRegionSto, 'aggregateId'>) {}
}
export class UpdateRegionSuccess implements Action {
  readonly type = UPDATE_REGION_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: Partial<TscRegionSto> & Pick<TscRegionSto, 'aggregateId'>
  ) {}
}
export class UpdateRegionFailure implements Action {
  readonly type = UPDATE_REGION_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: Partial<TscRegionSto> & Pick<TscRegionSto, 'aggregateId'>
  ) {}
}

export const GET_WORKSHOPS = '[TSC Workshops] Get Workshops';
export const GET_WORKSHOPS_SUCCESS = '[TSC Workshops] Get Workshops Success';
export const GET_WORKSHOPS_FAILURE = '[TSC Workshops] Get Workshops Failure';

export class GetWorkshops implements Action {
  readonly type = GET_WORKSHOPS;
  constructor(public payload: TscTicketQueryDto) {}
}
export class GetWorkshopsSuccess implements Action {
  readonly type = GET_WORKSHOPS_SUCCESS;
  constructor(public response: SoffApiResponseDto) {}
}
export class GetWorkshopsFailure implements Action {
  readonly type = GET_WORKSHOPS_FAILURE;
  constructor(public error: SoffApiExceptionDto) {}
}

export const GET_WORKSHOP = '[TSC Workshops] Get Workshop';
export const GET_WORKSHOP_SUCCESS = '[TSC Workshops] Get Workshop Success';
export const GET_WORKSHOP_FAILURE = '[TSC Workshops] Get Workshop Failure';

export class GetWorkshop implements Action {
  readonly type = GET_WORKSHOP;
  constructor(public payload: { workshopId: string; force?: true }) {}
}
export class GetWorkshopSuccess implements Action {
  readonly type = GET_WORKSHOP_SUCCESS;
  constructor(public response: SoffApiResponseDto) {}
}
export class GetWorkshopFailure implements Action {
  readonly type = GET_WORKSHOP_FAILURE;
  constructor(public error: SoffApiExceptionDto) {}
}

export const UPDATE_WORKSHOP = '[TSC Workshops] Update Workshop';
export const UPDATE_WORKSHOP_SUCCESS = '[TSC Workshops] Update Workshop Success';
export const UPDATE_WORKSHOP_FAILURE = '[TSC Workshops] Update Workshop Failure';
export class UpdateWorkshop implements Action {
  readonly type = UPDATE_WORKSHOP;
  constructor(public payload: Partial<TscWorkshopSto> & Pick<TscWorkshopSto, 'aggregateId'>) {}
}
export class UpdateWorkshopSuccess implements Action {
  readonly type = UPDATE_WORKSHOP_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: Partial<TscWorkshopSto> & Pick<TscWorkshopSto, 'aggregateId'>
  ) {}
}
export class UpdateWorkshopFailure implements Action {
  readonly type = UPDATE_WORKSHOP_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: Partial<TscWorkshopSto> & Pick<TscWorkshopSto, 'aggregateId'>
  ) {}
}

export const GET_EMPLOYEES = '[TSC Employees] Get Employees';
export const GET_EMPLOYEES_SUCCESS = '[TSC Employees] Get Employees Success';
export const GET_EMPLOYEES_FAILURE = '[TSC Employees] Get Employees Failure';

export class GetEmployees implements Action {
  readonly type = GET_EMPLOYEES;
  constructor(public payload: TscTicketQueryDto) {}
}
export class GetEmployeesSuccess implements Action {
  readonly type = GET_EMPLOYEES_SUCCESS;
  constructor(public response: SoffApiResponseDto) {}
}
export class GetEmployeesFailure implements Action {
  readonly type = GET_EMPLOYEES_FAILURE;
  constructor(public error: SoffApiExceptionDto) {}
}

export const GET_EMPLOYEE = '[TSC Employees] Get Employee';
export const GET_EMPLOYEE_SUCCESS = '[TSC Employees] Get Employee Success';
export const GET_EMPLOYEE_FAILURE = '[TSC Employees] Get Employee Failure';
export const GET_EMPLOYEE_CACHED = '[TSC Employees] Get Employee Cached';

export class GetEmployee implements Action {
  readonly type = GET_EMPLOYEE;
  constructor(public payload: { userId: string; force?: boolean }) {}
}
export class GetEmployeeSuccess implements Action {
  readonly type = GET_EMPLOYEE_SUCCESS;
  constructor(public response: SoffApiResponseDto) {}
}
export class GetEmployeeFailure implements Action {
  readonly type = GET_EMPLOYEE_FAILURE;
  constructor(public error: SoffApiExceptionDto) {}
}
// Dispatched instead of GetEmployeeSuccess/Failure when the effect finds the employee already cached, so employeeLoading doesn't get stuck at true (#371589).
export class GetEmployeeCached implements Action {
  readonly type = GET_EMPLOYEE_CACHED;
}

export const UPDATE_EMPLOYEE = '[TSC Employees] Update Employee';
export const UPDATE_EMPLOYEE_SUCCESS = '[TSC Employees] Update Employee Success';
export const UPDATE_EMPLOYEE_FAILURE = '[TSC Employees] Update Employee Failure';

export class UpdateEmployee implements Action {
  readonly type = UPDATE_EMPLOYEE;
  constructor(public payload: Partial<TscEmployeeSto> & Pick<TscEmployeeSto, 'aggregateId'>) {}
}
export class UpdateEmployeeSuccess implements Action {
  readonly type = UPDATE_EMPLOYEE_SUCCESS;
  constructor(
    public response: SoffApiResponseDto,
    public payload: Partial<TscEmployeeSto> & Pick<TscEmployeeSto, 'aggregateId'>
  ) {}
}
export class UpdateEmployeeFailure implements Action {
  readonly type = UPDATE_EMPLOYEE_FAILURE;
  constructor(
    public error: SoffApiExceptionDto,
    public payload: Partial<TscEmployeeSto> & Pick<TscEmployeeSto, 'aggregateId'>
  ) {}
}

export type Actions =
  | GetDisplayStatus
  | GetDisplayStatusSuccess
  | GetDisplayStatusFailure
  | CreateDisplayStatus
  | CreateDisplayStatusSuccess
  | CreateDisplayStatusFailure
  | UpdateDisplayStatus
  | UpdateDisplayStatusSuccess
  | UpdateDisplayStatusFailure
  | GetEscalationPatterns
  | GetEscalationPatternsSuccess
  | GetEscalationPatternsFailure
  | GetVkorgs
  | GetVkorgsSuccess
  | GetVkorgsFailure
  | GetRegions
  | GetRegionsSuccess
  | GetRegionsFailure
  | GetWorkshops
  | GetWorkshopsSuccess
  | GetWorkshopsFailure
  | GetWorkshop
  | GetWorkshopSuccess
  | GetWorkshopFailure
  | UpdateWorkshop
  | UpdateWorkshopSuccess
  | UpdateWorkshopFailure
  | GetEmployees
  | GetEmployeesSuccess
  | GetEmployeesFailure
  | GetEmployee
  | GetEmployeeSuccess
  | GetEmployeeFailure
  | GetEmployeeCached
  | UpdateEmployee
  | UpdateEmployeeSuccess
  | UpdateEmployeeFailure;
